import React from 'react';
import Header from 'components/header';
import GalleryGroup from './gallery-group';
import _ from 'lodash';
import moment from 'moment';


import './gallery.css';

const style = {
    gallery: {
        paddingTop: 56,
        paddingBottom: 60
    },
    avatar: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: 10,
        cursor: 'pointer'
    }
};

// Using "Stateless Functional Components"
const Gallery = function(props) {
    const groups = _.groupBy(props.assets, asset => {
        return moment(asset.creationDate).startOf('day').valueOf();
    });

    const dates = Object.keys(groups).sort().reverse();

    const galleyGroups = dates.map(date => {
        const m = moment(+date);
        const now = moment();
        let niceDate = m.format("dddd, MMMM Do YYYY");
        if (m.isSame(now, 'day')) {
            niceDate = 'Today'
        } else {
            const yesterday = now.subtract(1, 'day');
            if (m.isSame(yesterday, 'day')) {
                niceDate = 'Yesterday';
            }
        }
        return <GalleryGroup key={date} date={niceDate} assets={groups[date]}/>
    });

    return (
        <div style={style.gallery} className="wt-gallery-outer">
            <Header logout={props.logout} avatar={props.avatar}>My Uploads</Header>
            {galleyGroups}
        </div>
    );
};

export default Gallery;


